
import React, { useState, useContext } from 'react';
import ProcessButton from '../ProcessButton/ProcessButton.component';
import { FunctionContext } from '../../contexts/function.context';
import uploadFileToBlob, { isStorageConfigured } from '../../utils/azure/azure-storage-blob';


const UploadForm = (props) => {
  // all blobs in container
  const [blobList, setBlobList] = useState([]);
  const { currentFunctionCode } = useContext(FunctionContext);

  const storageConfigured = isStorageConfigured(props.envCode);

  // current file to upload into container
  const [fileSelected, setFileSelected] = useState(null);

  // UI/form management
  const [uploading, setUploading] = useState(false);
  const [inputKey, setInputKey] = useState(Math.random().toString(36));

  const onFileChange = (event) => {
    // capture file into state
    setFileSelected(event.target.files[0]);
    setBlobList([]);
  };

  const onFileUpload = async () => {
    // prepare UI
    setUploading(true);

    // *** UPLOAD TO AZURE STORAGE ***
    const blobsInContainer = await uploadFileToBlob(fileSelected,currentFunctionCode.path,props.envCode);

    // prepare UI for results
    setBlobList(blobsInContainer);

    // reset state/form
    //setFileSelected(null);
    setUploading(false);
    setInputKey(Math.random().toString(36));
  };

  // display form
  const DisplayForm = () => (
    <div>
      <input type="file" onChange={onFileChange} key={inputKey || ''} />
      <button type="submit" onClick={onFileUpload}>
        Upload!
          </button>
    </div>
  )

  // display file name and image
  const DisplayImagesFromContainer = () => (
    <div>
      <div>
        {blobList.filter((item) => {
          if(process.env.REACT_APP_LOGGING_LEVEL === '2') {
            console.log('Filtering item = ', item);
            console.log('Comparing item = ', fileSelected.name);
          }     
          return item.includes(currentFunctionCode.path + '/' + fileSelected.name );
        }).map((file) => {
          return (
            <div>
            <h2 key='select_file_to_process_key'>Select File to Process</h2>
            <ProcessButton  key={currentFunctionCode.path + '/' + fileSelected.name} 
              buttonText={currentFunctionCode.path + '/' + fileSelected.name} 
              buttonUrl={currentFunctionCode.url} 
              fileName={currentFunctionCode.path + '/' + fileSelected.name}
              envCode={props.envCode}
            />
            </div>
              
          );
        })}
      </div>
    </div>
  );

  if (currentFunctionCode) {
    if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
      console.log(JSON.stringify(currentFunctionCode));
    }
    if (currentFunctionCode.type === 'Upload') {
      return (
        <div>
          <h1>Upload {currentFunctionCode.code} file to {currentFunctionCode.path} Blob Storage folder</h1>
          {storageConfigured && !uploading && DisplayForm()}
          {storageConfigured && uploading && <div>Uploading</div>}
          <hr />
          {storageConfigured && blobList.length > 0 && DisplayImagesFromContainer()}
          {!storageConfigured && <div>Storage is not configured.</div>}
        </div>
      );

    }
  
  }

};

export default UploadForm;